import {
  UPDATE_TRIBUN_COUPON_NAME_REQUEST,
  UPDATE_TRIBUN_COUPON_NAME_SUCCESS,
  UPDATE_TRIBUN_COUPON_NAME_FAILURE,

  DELETE_TRIBUN_COUPON_NAME_REQUEST,
  DELETE_TRIBUN_COUPON_NAME_SUCCESS,
  DELETE_TRIBUN_COUPON_NAME_FAILURE,

} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TRIBUN_COUPON_NAME_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_TRIBUN_COUPON_NAME_SUCCESS:
      return { ...state, data: {
        ...action.payload
      }, isLoading: false, error: null };
    case UPDATE_TRIBUN_COUPON_NAME_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case DELETE_TRIBUN_COUPON_NAME_REQUEST:
      return { ...state, isLoading: true, error: null };
    case DELETE_TRIBUN_COUPON_NAME_SUCCESS:
      return { ...state, data: {
        ...action.payload
      }, isLoading: false, error: null };
    case DELETE_TRIBUN_COUPON_NAME_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
